import React, { useState, useEffect } from "react";
import { Box, CardContent, Stack, Tab, Tabs, Typography } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import { ErrorChips, SuccessChips } from "../../assets/styled-components/chips";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import axios from "axios";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import { BemsGraph, FemsGraph, MasterGraph } from "../../utility/apiURLS";
import commonMessages from "../../utility/constant";
import { updateOutsourceDetails, updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const Wostatuscompletetoauthorize = () => {
  const allMonths = commonMessages.months;
  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(0);
  const [year, setYear] = useState({ label: currentYear.toString(), value: currentYear.toString() });
  const [month, setMonth] = useState(allMonths[currentMonthIndex]);
  const [monthsOptions, setMonthsOptions] = useState([]);
  const [yearsOptions, setYearsOptions] = useState([]);

  const [scheduledData, setScheduledData] = useState([]);
  const [unscheduledData, setUnscheduledData] = useState([]);

  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);

  const fetchMaintenanceYears = async () => {
    const facilityId = getFacilityId();
    try {
      const response = await axios.get(`${MasterGraph}/api/GraphMaintenanceYear/GetMaintenanceYearByFacilityId/${facilityId}?page=1&size=100`);
      const years = response.data.items.map(y => ({
        label: y.maintyearvalue.toString(),
        value: y.maintyearvalue.toString()
      }));
      setYearsOptions(years);
    } catch (error) {
      console.error("Error fetching maintenance years:", error);
    }
  };

  const fetchDataWoageing = async () => {
    const token = getAuthToken("id_token");
    const facilityId = getFacilityId();
    const config = { headers: { Authorization: `Bearer ${token}` } };

    try {
      const [femRes, bemRes] = await Promise.all([
        axios.get(`${FemsGraph}/api/FEMSDashboardWidgets/GetDashboardCountWOageing/${facilityId}/${month?.id}/${year?.value}/2`, config),
        axios.get(`${BemsGraph}/api/BEMSDashboardWidgets/GetDashboardCountWOageing/${facilityId}/${month?.id}/${year?.value}/2`, config),
      ]);

      // Merge FEMS + BEMS scheduled
      const femScheduled = femRes.data?.totalSchWorkOrderCompletestatus || [];
      const bemScheduled = bemRes.data?.totalSchWorkOrderCompletestatus || [];
      setScheduledData([...femScheduled, ...bemScheduled]);

      // Merge FEMS + BEMS unscheduled
      const femUnscheduled = femRes.data?.totalUnschWorkOrderCompletestatus || [];
      const bemUnscheduled = bemRes.data?.totalUnschWorkOrderCompletestatus || [];
      setUnscheduledData([...femUnscheduled, ...bemUnscheduled]);

    } catch (error) {
      console.error("Error fetching work order ageing data:", error);
    }
  };

  useEffect(() => {
    const selectedYearValue = parseInt(year.value, 10);
    const updatedMonths = selectedYearValue === currentYear
      ? [...allMonths.slice(0, currentMonthIndex + 1)]
      : [...allMonths];

    setMonthsOptions(updatedMonths);
    setMonth(selectedYearValue === currentYear ? allMonths[currentMonthIndex] : allMonths[0]);
  }, [year]);

  useEffect(() => {
    fetchMaintenanceYears();
  }, []);

  useEffect(() => {
    fetchDataWoageing();
  }, [year, month]);

  useEffect(() => {
    if (selectedTab === 0) {
      setRowData(formatData(scheduledData));
    } else if (selectedTab === 1) {
      setRowData(formatData(unscheduledData));
    } else {
      setRowData([]);
    }
  }, [selectedTab, scheduledData, unscheduledData]);

  const handleYearChange = (newValue) => setYear(newValue);
  const handleMonthChange = (newValue) => setMonth(newValue);
  const handleTabChange = (_event, newValue) => setSelectedTab(newValue);

  const formatData = (list) => {
    return list?.map(item => ({
      ...item
    })) ?? [];
  };

  const handleLinkClick = (rowData) => (event) => {

    event.preventDefault(); // Prevent default link navigation

    const serviceType = rowData?.service === "FEMS" ? "fem" : "bem";
    const categoryType = rowData?.workordercategory === "Scheduled" ? "Scheduled" : "Unscheduled";
    dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
    dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
    dispatch(updateOutsourceDetails("SET_VENDORFIELD", false));
    dispatch({
      type: "SERVICE&CATEGORY_TYPE", payload: {
        assetType: serviceType,
        category: categoryType
      }
    });
    dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: rowData?.workorderStatus, percentage: 0 }))
    const title = `Edit ${categoryType} Work Order`;

    // Navigate with state parameters
    navigate("/workorder/register", {
      state: {
        ...rowData, service: serviceType, id: rowData?.workorderId, readOnly: false, editmode: true, category: categoryType, viewmode: false, isHyperlink: false, title,
        year: currentYear,
        month: { value: month?.value, label: month?.label, id: month?.id },
        isChange: true,
        workordertype: rowData?.workorderType,

      }
    });
    // navigate("/workorder/register", { state: { title, deptid: deptData,isCreateMode:true, year: year?.value,
    //   month: { value: month?.value, label: month?.label, id: month?.id } } },
    // );

  };

  const colDef = [
    {
      field: "workorderno",
      headerName: "Work Order No",
      minWidth: 200,
      cellRenderer: (params) => {
        return (
          <a
            href="#"
            onClick={(e) => handleLinkClick(params?.data)(e)}
            style={{ textDecoration: 'underline', color: '#1a73e8' }}
          >
            {params.value}
          </a>
        );
      },
    },
    { field: "service", headerName: "Service", minWidth: 150 },
    { field: "workorderdate", headerName: "Work Order Date", minWidth: 150 },
    {
      field: "workorderStatus",
      headerName: "Status",
      minWidth: 150,
      cellRenderer: (params) =>
        params.value === "Open" ? <ErrorChips label={params.value} /> : <SuccessChips label={params.value} />
    },
    { field: "workrequestdetails", headerName: "Work Request Details", minWidth: 200 },
  ];

  return (
    <StyledCard>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
          <Typography mb={1.5} variant="h5" fontWeight={700} color="text.primary">
            W.O Status Complete to Authorized
          </Typography>

          <Stack direction="row" alignItems="center" gap={1}>
            <CustomSelectInput
              fullWidth={false}
              labelSize="14px"
              sx={{ width: 100 }}
              label="Year"
              options={yearsOptions}
              value={year}
              onChange={handleYearChange}
              placeholder="Select Year"
              disableClearable
              highlight
            />
            <CustomSelectInput
              fullWidth={false}
              labelSize="14px"
              sx={{ width: 80 }}
              label="Month"
              options={monthsOptions}
              value={month}
              onChange={handleMonthChange}
              placeholder="Select Month"
              disableClearable
              highlight
            />
          </Stack>
        </Stack>

        <Tabs value={selectedTab} onChange={handleTabChange} aria-label="Work Order Status Tabs">
          <Tab label="Scheduled" />
          <Tab label="Unscheduled" />
        </Tabs>

        <Box mt={2}>
          <CustomAgGrid
            columns={colDef}
            rows={rowData}
            gridApi={gridApi}
            setGridApi={setGridApi}
            pagination={false}
            height={260}
            disableFilter
          />
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default Wostatuscompletetoauthorize;
